import { ErrorHandler, Injectable, Injector } from '@angular/core';

import { ErrorReportingService } from './error-reporting.service';

/**
 * `ErrorHandler` custom (SPEC, "Client"): logga sempre in console (non perdere la visibilità in
 * devtools) e inoltra al reporter. Non rilancia MAI, non mostra MAI UI.
 *
 * Risolve {@link ErrorReportingService} tramite `Injector` invece che come dipendenza diretta del
 * costruttore: `ErrorHandler` viene istanziato prestissimo nel bootstrap, e una dipendenza diretta
 * rischierebbe un ordine di creazione fragile se il reporter (o le sue dipendenze: `Router`,
 * `NetworkService`, ...) non fossero ancora pronte. La risoluzione lazy sposta il rischio al primo
 * errore effettivo, quando l'injector applicativo è certamente completo.
 */
@Injectable()
export class ClientErrorHandler implements ErrorHandler {
  constructor(private readonly injector: Injector) {}

  handleError(error: unknown): void {
    // Comportamento voluto: non perdere la visibilità dell'errore in devtools.
    console.error(error);
    try {
      this.injector.get(ErrorReportingService).reportJsError(error);
    } catch {
      // Il reporter non deve MAI rientrare qui: nessun console.error sull'esito di questo tentativo.
    }
  }
}
